import { DocumentUpload, Tag, TickSquare } from "iconsax-react";
import { FreeTrialServiceStepProps } from "../../types/free-trial/steps/type";

export const AUTO_TAGGING_SERVICE_STEPS: FreeTrialServiceStepProps[] = [
  { id: "upload-pic", label: "Upload Image", svg: <DocumentUpload variant="Broken" /> },
  { id: "auto-tagging", label: "Processing", svg: <Tag variant="Broken" /> },
  { id: "result", label: "Result", svg: <TickSquare variant="Broken" /> },
];
